import React, {FC, useState, useEffect} from 'react';
import PaymentItem from '../paymentHeader';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import PaymentFooter from '../paymentFooter';
import PaymentSuccess from '../paymentSuccess';
import PaymentLoader from '../paymentLoader';
import {IPayment, CardStateData} from '../../types';
import {useMutation, useQuery} from '@apollo/react-hooks';
import {ADD_CARD, SUBSCRIBTION} from '../../../graphql/mutations';
import {LIST_CUSTOMER_CARD} from '../../../graphql/queries';
import CreditCardForm from '../../creditCardForm';
import ChooseCard from '../paymentChooseCard';
import './styles.scss';

export const removeItem = () => {
  localStorage.removeItem('packageInfo');
};

const cardsFirstNumbers: any = {
  VISA: '4242',
  MASTERCARD: '5555',
  'AMERICAN EXPRESS': '3782',
  DISCOVER: '6011',
  DINERSCLUB: '3056',
  JCB: '3566',
  UNIONPAY: '6200',
  'DINERS CLUB': '3056',
};

const PaymentInfo: FC<IPayment> = ({
  name,
  selectedValue,
  price,
  packeges,
  user,
  setShowPopup,
  id,
  refetch,
  interval,
}) => {
  //states
  const [stripe, setStripe] = useState<any>(null);
  const [cardId, setCardId] = useState('');
  const [selectedPackege, setSelectedPackage] = useState({
    name,
    price,
    id,
  });
  const [customLoading, setCustumLoading] = useState(false);
  const [showPackeges, setShowPackeges] = useState(false);
  const [selectValue, setSelectValue] = useState(selectedValue);

  const [cardInfo, setCardInfo] = useState({
    name: '',
    number: '',
    expiry: '',
    cvc: '',
    focus: '',
  });
  const [defaultCardInfo, setDefaultCardInfo] = useState({
    name: '',
    number: '',
    expiry: '',
    cvc: '',
    focus: '',
  });
  const [editCardInfo, setEditCardInfo] = useState(false);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState(false);
  const [fieldError, setFieldError] = useState(false);
  //queries
  const {data: creditCards, loading: cardsLoading, refetch: refetchCardList} = useQuery(LIST_CUSTOMER_CARD, {
    fetchPolicy: 'no-cache',
    variables: {
      settings: {
        limit: 100,
      },
    },
  });
  const [addPaymentMethod, {loading}] = useMutation(ADD_CARD);
  const [createSubscription] = useMutation(SUBSCRIBTION);

  //useEffects

  useEffect(() => {
    refetch();
    removeItem();
    //@ts-ignore
    window['Stripe'].setPublishableKey(
      window.location.hostname.includes('hexomatic.com')
        ? 'pk_live_8KwSrH69LnrJea7rrCH7Phn1'
        : 'pk_test_awe3SQdhRsX7VjRATH8uPbyW',
    );
    setStripe(
      //@ts-ignore
      window['Stripe'](
        window.location.hostname.includes('hexomatic.com')
          ? 'pk_live_8KwSrH69LnrJea7rrCH7Phn1'
          : 'pk_test_awe3SQdhRsX7VjRATH8uPbyW',
      ),
    );
  }, []);

  useEffect(() => {
    if (
      creditCards &&
      creditCards.Billing &&
      creditCards.Billing.listCustomerCards &&
      creditCards.Billing.listCustomerCards.cards
    ) {
      const defaultCard =
        creditCards.Billing.listCustomerCards.cards.length === 1
          ? creditCards.Billing.listCustomerCards.cards[0]
          : creditCards.Billing.listCustomerCards.cards.find((item: any) => item.isDefault === 'true');
      defaultCard && setCardId(defaultCard.id);
      defaultCard &&
        setDefaultCardInfo({
          cvc: '***',
          expiry: '**/**',
          focus: defaultCard.brand,
          name: '**** ****',
          number:
            (cardsFirstNumbers[defaultCard.brand.toUpperCase()]
              ? cardsFirstNumbers[defaultCard.brand.toUpperCase()]
              : '****') +
            '********' +
            defaultCard.lastDigits,
        });
    }
  }, [creditCards]);

  useEffect(() => {
    setErr('');
  }, [editCardInfo]);

  useEffect(() => {
    if (success) refetch();
  }, [success]);
  useEffect(() => {
    if (err) {
      setCustumLoading(false);
      setTimeout(() => setErr(''), 10000);
    }
  }, [err]);
  //functions
  const handlePaymentFormSubmit = async () => {
    setErr('');
    const obj = {...cardInfo, focus: 'name'};
    if (Object.values(obj).filter(item => !item).length > 0) {
      setFieldError(true);
      return;
    }
    setFieldError(false);
    setCustumLoading(true);
    handlePayment(obj);
  };

  const handlePayment = async (cardData: CardStateData) => {
    const expiry = cardData.expiry.split('/');
    try {
      //@ts-ignore
      window.Stripe.card.createToken(
        {
          number: cardData.number,
          exp_month: +expiry[0],
          exp_year: +expiry[1].slice(0, 2),
          cvc: cardData.cvc,
        },
        //@ts-ignore
        (status, response) => {
          if (status === 200) {
            if (response && response.id) addCard(cardData, response.id);
            else setErr('Invalid parameters.');
          } else setErr('Invalid parameters.');
        },
      );
    } catch {
      setErr('Something went wrong');
    }
  };
  const addCard = async (cardData: CardStateData, id: string) => {
    try {
      const res = await addPaymentMethod({
        variables: {
          settings: {
            email: user && user.email,
            name: cardData.name,
            source: id,
          },
        },
      });
      const errors =
        res && res.data && res.data.BillingOps && res.data.BillingOps.addCard
          ? res.data.BillingOps.addCard.error_code
          : null;
      if (errors) setErr('Something went wrong.');
      if (res && res.data && res.data.BillingOps && res.data.BillingOps.addCard && res.data.BillingOps.addCard.cardId) {
        await handleUpgrade(res.data.BillingOps.addCard.cardId);
      }
      refetchCardList();
      setCustumLoading(false);
    } catch {
      setErr('Something went wrong.');
    }
  };

  const analytics = () => {
    if (window.location.href.includes('hexomatic.com')) {
      //@ts-ignore
      window.dataLayer.push({
        event: 'purchase-button-click',
        purchaseOrderId: new Date().toISOString(),
        purchaseConversionValue: `${(selectedPackege.price || 0) * (selectValue?.value || 1)}`,
      });
      //@ts-ignore
      window.dataLayer.push({
        event: 'eec.purchase',
        ecommerce: {
          currencyCode: 'USD',
          purchase: {
            actionField: {
              id: `${selectedPackege.name}_${new Date().toISOString()}`,
              revenue: `${(selectedPackege.price || 0) * (selectValue?.value || 1)}`,
            },
            products: [
              {
                item_id: `${selectedPackege.name}_${new Date().toISOString()}`,
                item_name: `${selectedPackege.name}_${interval?.toUpperCase()}`,
                price: `${selectedPackege.price || 0}`,
                quantity: selectValue?.value || 1,
              },
            ],
          },
        },
      });
    }
  };

  const handleUpgrade = async (card: string) => {
    try {
      setCustumLoading(true);
      setSuccess(false);
      setErr('');
      setFieldError(false);
      const res = await createSubscription({
        variables: {
          settings: {
            productId: selectedPackege.id,
            cardId: card,
            credits_pricing_package_count: selectValue?.value || 1,
          },
        },
      });
      if (
        res &&
        res.data &&
        res.data.HexomaticUserOps &&
        res.data.HexomaticUserOps.updateUserHexomaticPackage &&
        res.data.HexomaticUserOps.updateUserHexomaticPackage.clientSecret
      ) {
        //@ts-ignore
        const {paymentIntent, error} = await stripe.confirmCardPayment(
          res.data.HexomaticUserOps.updateUserHexomaticPackage.clientSecret,
          {
            payment_method: res.data.HexomaticUserOps.updateUserHexomaticPackage.card,
          },
        );
        if (paymentIntent && paymentIntent.status === 'succeeded') {
          setSuccess(true);
          analytics();
        } else setErr('Payment failed.');
        setCustumLoading(false);
        return;
      }
      if (
        res &&
        res.data &&
        res.data.HexomaticUserOps &&
        res.data.HexomaticUserOps.updateUserHexomaticPackage &&
        res.data.HexomaticUserOps.updateUserHexomaticPackage.error_code
      ) {
        setErr('Payment failed.');
      } else {
        setSuccess(true);
        analytics();
      }
      setCustumLoading(false);
    } catch (err) {
      setErr('Something went wrong.');
    }
  };

  return (
    <div className="payment" onClick={() => showPackeges && setShowPackeges(false)}>
      <span
        onClick={() => {
          setShowPopup(false);
          removeItem();
        }}
        className="modal-close"
      >
        {
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.88111 4.00011L7.8722 1.00889C7.95447 0.926545 7.99987 0.816691 8 0.699553C8 0.58235 7.9546 0.472366 7.8722 0.390155L7.61008 0.128106C7.52767 0.0455695 7.41782 0.000366211 7.30055 0.000366211C7.18348 0.000366211 7.07363 0.0455695 6.99122 0.128106L4.00013 3.11913L1.00891 0.128106C0.926634 0.0455695 0.816715 0.000366211 0.699512 0.000366211C0.582439 0.000366211 0.47252 0.0455695 0.390244 0.128106L0.128 0.390155C-0.0426667 0.560821 -0.0426667 0.838415 0.128 1.00889L3.11915 4.00011L0.128 6.9912C0.0456585 7.07367 0.000325203 7.18352 0.000325203 7.30066C0.000325203 7.4178 0.0456585 7.52765 0.128 7.61006L0.390179 7.87211C0.472455 7.95458 0.582439 7.99985 0.699447 7.99985C0.81665 7.99985 0.926569 7.95458 1.00885 7.87211L4.00006 4.88102L6.99115 7.87211C7.07356 7.95458 7.18341 7.99985 7.30049 7.99985H7.30062C7.41776 7.99985 7.52761 7.95458 7.61002 7.87211L7.87213 7.61006C7.95441 7.52772 7.9998 7.4178 7.9998 7.30066C7.9998 7.18352 7.95441 7.07367 7.87213 6.99126L4.88111 4.00011Z"
              fill="#8C979D"
            />
          </svg>
        }
      </span>
      {!customLoading && !loading ? (
        !success ? (
          <>
            <div
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <PaymentItem
                name={selectedPackege.name}
                selectedValue={selectValue}
                price={selectedPackege.price}
                showPackeges={showPackeges}
                onChange={() => setShowPackeges(!showPackeges)}
                selected
                checked
                handelSelectChange={setSelectValue}
                user={user}
                id={id}
              />
              {showPackeges && (
                <div className="packeges-list">
                  {packeges &&
                    packeges.length > 0 &&
                    packeges.map(
                      item =>
                        !item.disabled && (
                          <PaymentItem
                            disabled={item.disabled}
                            name={item.name}
                            selectedValue={selectValue}
                            price={item.price}
                            showPackeges
                            checked={item.name.toLocaleLowerCase() === selectedPackege.name.toLocaleLowerCase()}
                            handelSelectChange={setSelectValue}
                            onRadioChange={() => {
                              item.name !== selectedPackege.name &&
                                !item.disabled &&
                                setSelectedPackage({
                                  name: item.name,
                                  price: item.price,
                                  id: item.id,
                                });
                              setShowPackeges(false);
                            }}
                            id={id}
                          />
                        ),
                    )}
                </div>
              )}
            </div>
            {cardsLoading ? (
              <div className="d-flex align-items-center mt-5 pt-5 justify-content-center">
                <FontAwesomeIcon icon={faSpinner} className="button-loading" />
              </div>
            ) : (
              <>
                {!cardsLoading && defaultCardInfo && defaultCardInfo.name && (
                  <ChooseCard onChange={(val: boolean) => setEditCardInfo(val)} editCardInfo={editCardInfo} />
                )}
                {!cardsLoading && (
                  <>
                    <CreditCardForm
                      cardInfo={defaultCardInfo.name && !editCardInfo ? defaultCardInfo : cardInfo}
                      loading={loading || cardsLoading}
                      error={err}
                      changeData={(info: CardStateData) => setCardInfo(info)}
                      disabled={!defaultCardInfo.name ? false : !editCardInfo}
                      fieldError={fieldError}
                      onSubmit={() => {}}
                    />
                    <PaymentFooter
                      confirm={() =>
                        defaultCardInfo.name && !editCardInfo ? handleUpgrade(cardId) : handlePaymentFormSubmit()
                      }
                    />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <PaymentSuccess />
        )
      ) : (
        <PaymentLoader />
      )}
    </div>
  );
};

export default PaymentInfo;
